import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import classNames from 'classnames'

import ImageLoader from '../../ImageLoader'

import * as pane from '../../../store/pane'
import * as pdp from '../../../store/productDetailPage'

function ProductZoomImage(props) {
  const imageClasses = classNames('zoom-image', {'is--zoomed': props.isZoomedIn && props.isDesktop})

  return (
    <div className="product-zoom-image">
      <ImageLoader
        className={imageClasses}
        onLoad={props.onLoad}
        role="presentation"
        src={props.currentZoomImage}
      />
    </div>
  )
}

ProductZoomImage.propTypes = {
  currentZoomImage: PropTypes.string,
  isDesktop: PropTypes.bool.isRequired,
  isZoomedIn: PropTypes.bool.isRequired,
  onLoad: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    currentZoomImage: pdp.currentZoomImage(state),
    isZoomedIn: pdp.isZoomedIn(state),
    isDesktop: pane.windowIsDesktop(state),
  }
}

export default connect(mapStateToProps)(ProductZoomImage)
